import css from "@css/modules/HottestDeals.module.scss"
import { StartRating } from "@components/StartRating"
import Link from "next/link"
import { getListingUrl } from "@utils/listingUrl"
import { addCurrency, formatMonth } from "@utils/index"
import { getDays, getTotalPrice, originImgURL, pointOnContractYearsString, renderPoints } from "@components/Listings/listings-page-utils"
import { ListingStatus } from "@components/Listings/ListingStatus"
import moment from "moment/moment"
import { ViewsColumn } from "../ViewsColumn"
import React from "react"
import { Listing } from "@t/Listing"
import { useRouter } from "next/navigation"
import cn from "classnames"
import { useMediaQuery } from "@utils/hooks/useMediaQuery"
import Image from "next/image"

type Props = Listing & { index: number }

export function DealRow({ index, ...i }: Props) {
    const router = useRouter()
    const specialDeedExp = i?.resort?.id === 11 && Number(i.deed_exp) === 2057 ? " (2057)" : ""
    const name = i?.resort?.short_name.replace("Resort", "") + specialDeedExp
    const isMobile = useMediaQuery("(max-width: 991px)")
    if (isMobile) {
        return (
            <div className={css.gridRowMobile} onClick={() => router.push(getListingUrl(i))}>
                <div className={css.mobileIdWrapper}>
                    <span>ID: {i?.id}</span>
                    <ListingStatus listing={i} />
                </div>
                <div className={css.resortCell}>
                    <Link prefetch={false} href={getListingUrl(i)} scroll className={css.listingLink}>
                        <div className={css.resortName}>
                            {name}
                            {originImgURL[i.origin] && <Image title={i.origin} className={css.originImg} alt={i.origin} src={originImgURL[i.origin]} width="16" height="16" />}
                        </div>
                    </Link>
                </div>
                <ul className={css.mobileList}>
                    <li>
                        <div>Points</div>
                        <div className={css.propValue}>{i.points_on_contract}</div>
                    </li>
                    <li>
                        <div>Pts. Available {pointOnContractYearsString}</div>
                        <div className={css.propValue}>{renderPoints(i)}</div>
                    </li>
                    <li>
                        <div>Price per point</div>
                        <div className={css.propValue}>{addCurrency(i.price_per_point)}</div>
                    </li>
                    <li>
                        <div>Price</div>
                        <div className={css.propValue}>{addCurrency(getTotalPrice(i))}</div>
                    </li>
                    <li>
                        <div>Month</div>
                        <div className={css.propValue}>{formatMonth(i.use_month)}</div>
                    </li>
                    <li>
                        <div>Days On Market</div>
                        <div className={css.propValue}>{getDays(i.parsed_date)}</div>
                    </li>
                    <li>
                        <div>Deal score</div>
                        <div>
                            <StartRating withShort className={css.stars} rating={i.stars} size={12} gap={4} />
                        </div>
                    </li>
                    <li>
                        <div></div>
                        <div className={css.propValue}>
                            <div className={css.mobileViews}>
                                <ViewsColumn {...i.listing_popularity} />
                            </div>
                        </div>
                    </li>
                </ul>
                <div className={css.viewDetails}>
                    <hr />
                    <a onClick={(e) => e.preventDefault()} className="Listings_viewDetails__Fxoz_" href="/listings/saratoga-springs-resort_116991">
                        View details
                    </a>
                </div>
            </div>
        )
    }
    return (
        <div className={css.gridRow} onClick={() => router.push(getListingUrl(i))}>
            <div>{index + 1}</div>
            <div>
                <StartRating withShort className={css.stars} rating={i.stars} size={12} gap={4} />
            </div>
            <div className={css.resortCell}>
                <Link prefetch={false} href={getListingUrl(i)} scroll className={css.listingLink}>
                    <div className={css.resortName}>{name}</div>
                    <div className={css.resortId}>
                        ID: {i?.id}{" "}
                        {originImgURL[i.origin] && <Image title={i.origin} className={css.originImg} alt={i.origin} src={originImgURL[i.origin]} width="16" height="16" />}
                    </div>
                </Link>
            </div>
            <div>{addCurrency(i.price_per_point)}</div>
            <div>{i.points_on_contract}</div>
            <div>{renderPoints(i)}</div>
            <div>{formatMonth(i.use_month)}</div>
            <div>{addCurrency(getTotalPrice(i))}</div>
            <div>
                <ListingStatus listing={i} />
            </div>
            <div className={cn(css.hiddenOnMobile)}>{moment(i.parsed_date).format("MM/DD/YYYY")}</div>
            <div className={cn(css.hiddenOnMobile)}>{getDays(i.parsed_date)}</div>
            <ViewsColumn {...i.listing_popularity} />
        </div>
    )
}
